import API from '../api';

export const getUniversityTypes = ({ signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get('/universities/university_types/', { signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
